module.exports = __webpack_public_path__ + "static/DarksideDetective2-be22fc0c78a052801d859b8591089d42.webp";